// src/components/StyledButton.js
import { styled } from '@mui/material/styles'; // Assuming you're using Material-UI
import Button from '@mui/material/Button'; // Import the base Button component

const StyledButton = styled(Button)(({ disabled }) => ({
  margin: "8px 4px 2px 4px",
  padding: "0 1px",
  height: "16px",
  lineHeight: "16px",
  width: "calc(50% - 6px)",
  textAlign: "center",
  fontSize: "12px",
  color: disabled ? "rgba(0, 0, 0, 0.38)" : "rgba(0, 0, 0, 0.8)",
  border: "1px solid transparent",
  borderRadius: "1px",
  backgroundColor: disabled ? "rgba(0, 0, 0, 0.12)" : "rgba(0, 0, 0, 0.18)",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: disabled ? "rgba(0, 0, 0, 0.12)" : "rgba(0, 0, 0, 0.3)",
    boxShadow: "none",
  },
}));

export default StyledButton;